import { handleErrorMessage, openSuccessNotification } from "helpers/methods";
import { resendAccountVerificationNotification } from "screens/Auth/AuthService";
import { verifyTempPasswordOfOnboardUser } from "./OnboardingServices";
import { activateUser } from "Services/CommonServices";
import history from "utils/history";
import { setAuthToken } from "redux/authSlice";
import { getAccountDisplayName } from "screens/Auth/authSession";
import urls from "global/constants/UrlConstants";
import viewpaths from "global/constants/ViewPathConstants";
import { getCurrentPlan } from "screens/Settings/MyPlan/PlanService";

export const verifyPwd = async (
  token: string,
  setLoading: Function,
  dispatch: Function,
  setError?: Function
) => {
  try {
    setLoading(true);
    const res = await verifyTempPasswordOfOnboardUser({
      authToken: token,
    });
    if (res) {
      if (res.planId === urls.planId || res.account === "esigners") {
        res.planId = urls.planId;
        const activatedRes = await activateUser(res, res.authToken, false);

        if (activatedRes) {
          openSuccessNotification("Account Activated Successfully!");
          // history.push(urls.landingViewPath);
        }
      } else {
        dispatch(
          setAuthToken({
            accessToken: res.authToken,
            email: res.email,
            name: res.name,
            account: res.account,
            accountDisplayName: getAccountDisplayName(res),
          })
        );
        const plan = await getCurrentPlan(res.account);
        history.push({
          pathname: viewpaths.onBoardingClient,
          state: {
            currentPlan: plan,
            user: res,
          },
        });
      }
    }
  } catch (error: any) {
    setError && setError(error.message);
    handleErrorMessage(error);
  } finally {
    setLoading(false);
  }
};

export const resendAccountVerificationEmail = async (
  setLoading: Function,
  userEmail: string
) => {
  try {
    setLoading(true);
    await resendAccountVerificationNotification(userEmail);
    openSuccessNotification("Account activation email sent Successfully!");
  } catch (error: any) {
    handleErrorMessage(error);
  } finally {
    setLoading(false);
  }
};
